import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { useState } from "react";
import RedeemPrizeConfirm from "./RedeemPrizeConfirm";
import RedeemPrizeSuccess from "./RedeemPrizeSuccess";
import RedeemPrizeFail from "./RedeemPrizeFail";
import useActiveItem from "hooks/useActiveItem";
import { useSoundPath } from "hooks/useSoundPath";
import ModalWindow from "components/ModalWindow";

const RedeemPrizePopup = ({close}) => {
  const [step, setStep] = useState('start');
  const {activeItem} = useActiveItem();
  const playSound = useSoundPath();

  const getPrizeValue = () => {
    return activeItem.properties.find((item) => item.title === 'Value').text;
  }

  const nextStep = (step) => {
    playSound('main');
    setStep(step)
  }

  return (
    <ModalWindow close={close}>
      <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={close} />
        {step === 'start' && <RedeemPrizeConfirm id={activeItem.id} value={getPrizeValue()} nextStep={nextStep} close={close} />}
        {step === 'success' && <RedeemPrizeSuccess close={close} />}
        {step === 'fail' && <RedeemPrizeFail close={close} />}
      </div>
    </ModalWindow>
  )
}

export default RedeemPrizePopup;
